export default __webpack_public_path__ + "static/media/open-stalls-white.7970e632.png";